import { db } from './firebase';
import { collection, addDoc, getDocs, query, orderBy, serverTimestamp, Timestamp, where } from 'firebase/firestore';

export const createJobPost = async (jobData, userId, userName) => {
  try {
    // Validate required fields
    if (!jobData.title || !jobData.company || !jobData.description) {
      throw new Error('Missing required fields');
    }

    const jobsRef = collection(db, 'jobs');
    const newJob = {
      title: jobData.title,
      company: jobData.company,
      location: jobData.location || '',
      description: jobData.description,
      applyLink: jobData.applyLink || '',
      postedBy: userName,
      postedById: userId,
      postedDate: serverTimestamp(),
      status: 'active',
      createdAt: Timestamp.now()
    };

    const docRef = await addDoc(jobsRef, newJob);
    console.log('Job created with ID:', docRef.id); // Debug log
    
    return {
      success: true,
      jobId: docRef.id,
      job: newJob
    };
  } catch (error) {
    console.error('Detailed error:', error); // Debug log
    return {
      success: false,
      error: error.message || 'Failed to create job post'
    };
  }
};

export const getJobPosts = async () => {
  try {
    const jobsRef = collection(db, 'jobs');
    const q = query(jobsRef, orderBy('postedDate', 'desc'));
    const snapshot = await getDocs(q);
    
    const jobs = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      postedDate: doc.data().postedDate?.toDate().toISOString()
    }));

    return {
      success: true,
      jobs
    };
  } catch (error) {
    console.error('Error fetching jobs:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

export const getMessages = async (userId) => {
  try {
    const messagesRef = collection(db, 'messages');
    // Query messages where user is either sender or receiver
    const q = query(
      messagesRef,
      where('participants', 'array-contains', userId),
      orderBy('timestamp', 'desc')
    );
    
    const querySnapshot = await getDocs(q);
    const messages = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      timestamp: doc.data().timestamp?.toDate()
    }));

    console.log('Fetched messages:', messages); // Debug log
    return messages;
  } catch (error) {
    console.error('Error getting messages:', error);
    throw error; // Propagate error to component for handling
  }
};

export const sendMessage = async ({senderId, receiverId, text}) => {
  try {
    if (!senderId || !receiverId || !text) {
      throw new Error('Missing required fields');
    }

    const messagesRef = collection(db, 'messages');
    const participants = [senderId, receiverId].sort();
    
    const messageData = {
      senderId,
      receiverId, 
      text,
      timestamp: serverTimestamp(),
      participants, // Array for querying
      read: false
    };

    const docRef = await addDoc(messagesRef, messageData);
    console.log('Message sent with ID:', docRef.id); // Debug log
    return true;
  } catch (error) {
    console.error('Error sending message:', error);
    throw error; // Propagate error to component for handling
  }
};
